import { DisplayEntity } from "../types";

export function inferDisplayTypeAndEntityFilter(
  d: DisplayEntity
): { contentType: "HTML" | "IMAGE" | "VIDEO"; entityFilter: "PROPERTY" | "ACCOMMODATION" } {
  // Backend doesn't store contentType, so we infer it from the data
  const htmlBlob = (d.translations ?? []).map(t => t.content || "").join(" ");
  const hasYoutubeInHtml =
    /VIDEO_DISPLAY_URL/i.test(htmlBlob) || /<iframe[^>]+(youtube\.com|youtu\.be)/i.test(htmlBlob);
  const hasImages = Array.isArray(d.multimedia) && d.multimedia.length > 0;

  const contentType: "HTML" | "IMAGE" | "VIDEO" = hasYoutubeInHtml
    ? "VIDEO"
    : hasImages
    ? "IMAGE"
    : "HTML";

  const tickerValues = d.conditions?.find(c => c.type === "TICKER")?.value ?? [];
  const entityFilter: "PROPERTY" | "ACCOMMODATION" =
    d.entityFilter ?? (tickerValues.length > 0 ? "ACCOMMODATION" : "PROPERTY");

  return { contentType, entityFilter };
}
